import '../assets/referencePickerModal-iy5QSWj6.css';
import { n as o } from "./_plugin-vue2_normalizer-u6G_3nkj.mjs";
import { r as h, O as E, a as n, P as N, Q as C, R as I, u as O, S as B, G as M, T as V } from "./_l10n-FmsZpnE4.mjs";
import f from "@nextcloud/axios";
import { loadState as P } from "@nextcloud/initial-state";
import { imagePath as W, generateOcsUrl as p } from "@nextcloud/router";
import _ from "../Components/NcEmptyContent.mjs";
import { N as w } from "./index-2phCrsSH.mjs";
import { N as b } from "./NcSelect-vSPKKiyt.mjs";
import q from "../Components/NcLoadingIcon.mjs";
import { N as T } from "./NcTextField-NnW31cA4.mjs";
import { D as j } from "./DotsHorizontal-IbmXTXRA.mjs";
import z from "../Components/NcButton.mjs";
import D from "../Components/NcModal.mjs";
import { emit as A } from "@nextcloud/event-bus";
import { A as F } from "./ArrowLeft-uW5eNVkY.mjs";
import { C as Q } from "./Close-QtH6_3PP.mjs";
import U from "vue";
window._vue_richtext_widgets || (window._vue_richtext_widgets = {});
const G = (t) => !!window._vue_richtext_widgets[t], H = (t, e, r = (s) => {
}) => {
  if (window._vue_richtext_widgets[t]) {
    console.error("Widget for id " + t + " already registered");
    return;
  }
  window._vue_richtext_widgets[t] = {
    id: t,
    callback: e,
    onDestroy: r
  };
}, Z = (t, { richObjectType: e, richObject: r, accessible: s, interactive: i }) => {
  if (e !== "open-graph") {
    if (!window._vue_richtext_widgets[e]) {
      console.error("Widget for rich object type " + e + " not registered");
      return;
    }
    window._vue_richtext_widgets[e].callback(t, { richObjectType: e, richObject: r, accessible: s, interactive: i });
  }
}, J = (t, e) => {
  t !== "open-graph" && window._vue_richtext_widgets[t] && window._vue_richtext_widgets[t].onDestroy(e);
};
window._registerWidget = H;
const K = {
  name: "NcReferenceWidget",
  props: {
    reference: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      compact: 3
    };
  },
  computed: {
    hasCustomWidget() {
      return G(this.reference.richObjectType);
    },
    noAccess() {
      return this.reference && !this.reference.accessible;
    },
    descriptionStyle() {
      if (this.compact === 0)
        return {
          display: "none"
        };
      const t = this.compact < 4 ? this.compact : 3;
      return {
        lineClamp: t,
        webkitLineClamp: t
      };
    },
    compactLink() {
      const t = this.reference.openGraphObject.link;
      return t ? t.startsWith("https://") ? t.substring(8) : t.startsWith("http://") ? t.substring(7) : t : "";
    }
  },
  mounted() {
    this.renderWidget(), this.observer = new ResizeObserver((t) => {
      t[0].contentRect.width < 450 ? this.compact = 0 : t[0].contentRect.width < 550 ? this.compact = 1 : t[0].contentRect.width < 650 ? this.compact = 2 : this.compact = 3;
    }), this.observer.observe(this.$el);
  },
  beforeDestroy() {
    this.observer.disconnect(), J(this.reference.richObjectType, this.$el);
  },
  methods: {
    renderWidget() {
      this.$refs.customWidget && (this.$refs.customWidget.innerHTML = ""), this?.reference?.richObjectType !== "open-graph" && this.$nextTick(() => {
        Z(this.$refs.customWidget, this.reference);
      });
    }
  }
};
var X = function() {
  var e = this, r = e._self._c;
  return r("div", [e.reference && e.hasCustomWidget ? r("div", { staticClass: "widget-custom" }, [r("div", { ref: "customWidget" })]) : !e.noAccess && e.reference && e.reference.openGraphObject && !e.hasCustomWidget ? r("a", { staticClass: "widget-default", attrs: { href: e.reference.openGraphObject.link, rel: "noopener noreferrer", target: "_blank" } }, [e.reference.openGraphObject.thumb ? r("img", { staticClass: "widget-default--image", attrs: { src: e.reference.openGraphObject.thumb } }) : e._e(), r("div", { staticClass: "widget-default--details" }, [r("p", { staticClass: "widget-default--name" }, [e._v(e._s(e.reference.openGraphObject.name))]), r("p", { staticClass: "widget-default--description", style: e.descriptionStyle }, [e._v(e._s(e.reference.openGraphObject.description))]), r("p", { staticClass: "widget-default--link" }, [e._v(e._s(e.compactLink))])])]) : e._e()]);
}, Y = [], ee = /* @__PURE__ */ o(
  K,
  X,
  Y,
  !1,
  null,
  "b1c5a80f",
  null,
  null
);
const te = ee.exports;
window._vue_richtext_custom_picker_elements || (window._vue_richtext_custom_picker_elements = {});
class ht {
  /**
   * @param {HTMLElement} element The HTML element
   * @param {object} object The object
   */
  constructor(e, r) {
    this.element = e, this.object = r;
  }
}
const d = (t) => !!window._vue_richtext_custom_picker_elements[t], re = (t) => {
  const e = window._vue_richtext_custom_picker_elements[t]?.size;
  return ["small", "normal", "large", "full"].includes(e) ? e : null;
}, se = (t, e, r = (i) => {
}, s = "large") => {
  if (window._vue_richtext_custom_picker_elements[t]) {
    console.error("Custom reference picker element for id " + t + " already registered");
    return;
  }
  window._vue_richtext_custom_picker_elements[t] = {
    id: t,
    callback: e,
    onDestroy: r,
    size: s
  };
}, ie = (t, { providerId: e, accessible: r }) => {
  if (!window._vue_richtext_custom_picker_elements[e]) {
    console.error("Custom reference picker element for reference provider ID " + e + " not registered");
    return;
  }
  return window._vue_richtext_custom_picker_elements[e].callback(t, { providerId: e, accessible: r });
}, ne = (t, e, r) => {
  window._vue_richtext_custom_picker_elements[t] && window._vue_richtext_custom_picker_elements[t].onDestroy(e, r);
};
window._registerCustomPickerElement = se;
const oe = {
  name: "NcCustomPickerElement",
  props: {
    /**
     * The reference provider
     */
    provider: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "cancel",
    "submit"
  ],
  data() {
    return {
      isRegistered: d(this.provider.id),
      renderResult: null
    };
  },
  mounted() {
    this.isRegistered && this.renderElement();
  },
  beforeDestroy() {
    this.isRegistered && ne(this.provider.id, this.$el, this.renderResult);
  },
  methods: {
    renderElement() {
      this.$refs.domElement && (this.$refs.domElement.innerHTML = "");
      const t = ie(this.$refs.domElement, { providerId: this.provider.id, accessible: !1 });
      Promise.resolve(t).then((e) => {
        this.renderResult = e, this.renderResult.object?._isVue && this.renderResult.object?.$on && (this.renderResult.object.$on("submit", this.onSubmit), this.renderResult.object.$on("cancel", this.onCancel)), this.renderResult.element.addEventListener("submit", (r) => {
          this.onSubmit(r.detail);
        }), this.renderResult.element.addEventListener("cancel", this.onCancel);
      });
    },
    onSubmit(t) {
      this.$emit("submit", t);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
};
var ce = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "domElement" });
}, le = [], ae = /* @__PURE__ */ o(
  oe,
  ce,
  le,
  !1,
  null,
  "cf695ff9",
  null,
  null
);
const ue = ae.exports;
h(E);
const S = "any-link", $ = {
  id: S,
  title: n("Any link"),
  icon_url: W("core", "filetypes/link.svg")
};
window._vue_richtext_reference_providers || (window._vue_richtext_reference_providers = P("core", "reference-provider-list", []));
window._vue_richtext_reference_provider_timestamps || (window._vue_richtext_reference_provider_timestamps = P("core", "reference-provider-timestamps", {}));
function de(t) {
  return t === S ? $ : R().find((e) => e.id === t);
}
function R() {
  return window._vue_richtext_reference_providers.filter((t) => {
    const e = !!t.search_providers_ids && t.search_providers_ids.length > 0 || d(t.id);
    return e || console.debug("[smart picker]", t.id, "reference provider is discoverable but does not have any related search provider or custom picker component registered"), e;
  });
}
function he(t) {
  const e = window._vue_richtext_reference_provider_timestamps;
  return t.sort((r, s) => r.order === s.order ? 0 : r.order > s.order ? 1 : -1).sort((r, s) => {
    const i = e[r.id], c = e[s.id];
    return i === c ? 0 : c === void 0 ? -1 : i === void 0 ? 1 : i > c ? -1 : 1;
  });
}
function me(t, e = null) {
  const r = R(), s = t.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&"), i = new RegExp(s, "i"), m = he(r).filter((l) => l.title.match(i)), a = e ? m.slice(0, e) : m;
  return (t === "" || a.length === 0) && a.push($), a;
}
function pe(t) {
  const e = Math.floor(Date.now() / 1e3), r = {
    timestamp: e
  }, s = p("references/provider/{providerId}", { providerId: t });
  f.put(s, r).then((i) => {
    window._vue_richtext_reference_provider_timestamps[t] = e;
  });
}
let k = 0;
function L(t, e) {
  return function() {
    const r = this, s = arguments;
    clearTimeout(k), k = setTimeout(function() {
      t.apply(r, s);
    }, e || 0);
  };
}
function v(t) {
  try {
    return !!new URL(t);
  } catch {
    return !1;
  }
}
h(C, N);
const fe = {
  name: "LinkVariantIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _e = function() {
  var e = this, r = e._self._c;
  return r("span", e._b({ staticClass: "material-design-icon link-variant-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(s) {
    return e.$emit("click", s);
  } } }, "span", e.$attrs, !1), [r("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [r("path", { attrs: { d: "M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z" } }, [e.title ? r("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, ve = [], ge = /* @__PURE__ */ o(
  fe,
  _e,
  ve,
  !1,
  null,
  null,
  null,
  null
);
const g = ge.exports, ke = {
  name: "NcProviderList",
  components: {
    NcSelect: b,
    NcHighlight: w,
    NcEmptyContent: _,
    LinkVariantIcon: g
  },
  emits: [
    "select-provider",
    "submit"
  ],
  data() {
    return {
      selectedProvider: null,
      query: "",
      multiselectPlaceholder: n("Select provider"),
      providerIconAlt: n("Provider icon")
    };
  },
  computed: {
    options() {
      const t = [];
      return this.query !== "" && v(this.query) && t.push({
        id: this.query,
        title: this.query,
        isLink: !0
      }), t.push(...me(this.query)), t;
    }
  },
  methods: {
    focus() {
      setTimeout(() => {
        this.$refs["provider-select"]?.$el?.querySelector("#provider-select-input")?.focus();
      }, 300);
    },
    onProviderSelected(t) {
      t !== null && (t.isLink ? this.$emit("submit", t.title) : this.$emit("select-provider", t), this.selectedProvider = null);
    },
    onSearch(t, e) {
      this.query = t;
    }
  }
};
var ye = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "provider-list" }, [r("NcSelect", { ref: "provider-select", staticClass: "provider-list--select", attrs: { "input-id": "provider-select-input", label: "title", placeholder: e.multiselectPlaceholder, options: e.options, "append-to-body": !1, "clear-search-on-select": !0, "clear-search-on-blur": () => !1, filterable: !1 }, on: { search: e.onSearch, input: e.onProviderSelected }, scopedSlots: e._u([{ key: "option", fn: function(s) {
    return [s.isLink ? r("div", { staticClass: "provider" }, [r("LinkVariantIcon", { staticClass: "link-icon", attrs: { size: 20 } }), r("span", [e._v(e._s(s.title))])], 1) : r("div", { staticClass: "provider" }, [r("img", { staticClass: "provider-icon", attrs: { src: s.icon_url, alt: e.providerIconAlt } }), r("NcHighlight", { staticClass: "option-text", attrs: { search: e.query, text: s.title } })], 1)];
  } }]), model: { value: e.selectedProvider, callback: function(s) {
    e.selectedProvider = s;
  }, expression: "selectedProvider" } }), r("NcEmptyContent", { staticClass: "provider-list--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("LinkVariantIcon")];
  }, proxy: !0 }]) })], 1);
}, Ce = [], Pe = /* @__PURE__ */ o(
  ke,
  ye,
  Ce,
  !1,
  null,
  "9d850ea5",
  null,
  null
);
const we = Pe.exports;
h(I);
const be = {
  name: "NcRawLinkInput",
  components: {
    LinkVariantIcon: g,
    NcEmptyContent: _,
    NcLoadingIcon: q,
    NcReferenceWidget: te,
    NcTextField: T
  },
  props: {
    /**
     * The reference provider
     */
    provider: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "submit"
  ],
  data() {
    return {
      inputValue: "",
      loading: !1,
      reference: null,
      abortController: null,
      inputPlaceholder: n("Enter link")
    };
  },
  computed: {
    isLinkValid() {
      return v(this.inputValue);
    }
  },
  methods: {
    focus() {
      this.$refs["url-input"].$el.getElementsByTagName("input")[0]?.focus();
    },
    onSubmit(t) {
      const e = t.target.value;
      this.isLinkValid && this.$emit("submit", e);
    },
    onClear() {
      this.inputValue = "", this.reference = null;
    },
    onInput() {
      this.reference = null, this.abortController && this.abortController.abort(), this.isLinkValid && L(() => {
        this.updateReference();
      }, 500)();
    },
    updateReference() {
      this.loading = !0, this.abortController = new AbortController(), f.get(p("references/resolve", 2) + "?reference=" + encodeURIComponent(this.inputValue), {
        signal: this.abortController.signal
      }).then((t) => {
        this.reference = t.data.ocs.data.references[this.inputValue];
      }).catch((t) => {
        console.error(t);
      }).then(() => {
        this.loading = !1;
      });
    }
  }
};
var Se = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "raw-link" }, [r("div", { staticClass: "input-wrapper" }, [r("NcTextField", { ref: "url-input", attrs: { value: e.inputValue, "show-trailing-button": e.inputValue !== "", label: e.inputPlaceholder }, on: { "update:value": [function(s) {
    e.inputValue = s;
  }, e.onInput], "trailing-button-click": e.onClear }, nativeOn: { keyup: function(s) {
    return !s.type.indexOf("key") && e._k(s.keyCode, "enter", 13, s.key, "Enter") ? null : e.onSubmit.apply(null, arguments);
  } } }, [e.loading ? r("NcLoadingIcon", { attrs: { size: 16 } }) : r("LinkVariantIcon", { attrs: { size: 16 } })], 1)], 1), e.reference !== null ? r("NcReferenceWidget", { staticClass: "reference-widget", attrs: { reference: e.reference } }) : r("NcEmptyContent", { staticClass: "raw-link--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e.provider.icon_url ? r("img", { staticClass: "provider-icon", attrs: { src: e.provider.icon_url } }) : r("LinkVariantIcon")];
  }, proxy: !0 }]) })], 1);
}, $e = [], Re = /* @__PURE__ */ o(
  be,
  Se,
  $e,
  !1,
  null,
  "d0ba247a",
  null,
  null
);
const Le = Re.exports, xe = {
  name: "NcSearchResult",
  components: {
    NcHighlight: w
  },
  props: {
    /**
     * Unified search result entry
     */
    entry: {
      type: Object,
      required: !0
    },
    /**
     * The query that led to getting this result
     * Used to highlight the entry text
     */
    query: {
      type: String,
      required: !0
    }
  }
};
var Ee = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "result" }, [e.entry.icon ? r("div", { staticClass: "result--icon-class", class: { [e.entry.icon]: !0, rounded: e.entry.rounded } }) : r("img", { staticClass: "result--image", class: { rounded: e.entry.rounded }, attrs: { src: e.entry.thumbnailUrl } }), r("div", { staticClass: "result--content" }, [r("span", { staticClass: "result--content--name" }, [r("NcHighlight", { attrs: { search: e.query, text: e.entry.title } })], 1), r("span", { staticClass: "result--content--subline" }, [r("NcHighlight", { attrs: { search: e.query, text: e.entry.subline } })], 1)])]);
}, Ne = [], Ie = /* @__PURE__ */ o(
  xe,
  Ee,
  Ne,
  !1,
  null,
  "7a394a58",
  null,
  null
);
const Oe = Ie.exports;
h(B, C, O);
const y = 5, Be = {
  name: "NcSearch",
  components: {
    LinkVariantIcon: g,
    DotsHorizontalIcon: j,
    NcEmptyContent: _,
    NcSelect: b,
    NcSearchResult: Oe
  },
  props: {
    /**
     * The selected reference provider
     */
    provider: {
      type: Object,
      required: !0
    },
    showEmptyContent: {
      type: Boolean,
      default: !0
    },
    searchPlaceholder: {
      type: String,
      default: null
    }
  },
  emits: [
    "submit"
  ],
  data() {
    return {
      searchQuery: "",
      selectedResult: null,
      resultsBySearchProvider: {},
      searching: !1,
      searchingMoreOf: null,
      abortController: null,
      noOptionsText: n("Start typing to search"),
      providerIconAlt: n("Provider icon")
    };
  },
  computed: {
    mySearchPlaceholder() {
      return this.searchPlaceholder || n("Search");
    },
    searchProviderIds() {
      return this.provider.search_providers_ids;
    },
    options() {
      if (this.searchQuery === "")
        return [];
      const t = [];
      return v(this.searchQuery) && t.push(this.rawLinkEntry), t.push(...this.formattedSearchResults), t;
    },
    rawLinkEntry() {
      return {
        id: "rawLinkEntry",
        resourceUrl: this.searchQuery,
        isRawLink: !0
      };
    },
    formattedSearchResults() {
      const t = [];
      return this.searchProviderIds.forEach((e) => {
        if (this.resultsBySearchProvider[e].entries.length > 0) {
          (this.searchProviderIds.length > 1 || this.resultsBySearchProvider[e].entries.length > 1) && t.push({
            id: "groupTitle-" + e,
            name: this.resultsBySearchProvider[e].name,
            isCustomGroupTitle: !0,
            providerId: e
          });
          const r = this.resultsBySearchProvider[e].entries.map((s, i) => ({
            id: "provider-" + e + "-entry-" + i,
            ...s
          }));
          t.push(...r), this.resultsBySearchProvider[e].isPaginated && t.push({
            id: "moreOf-" + e,
            name: this.resultsBySearchProvider[e].name,
            isMore: !0,
            providerId: e,
            isLoading: this.searchingMoreOf === e
          });
        }
      }), t;
    }
  },
  mounted() {
    this.resetResults();
  },
  beforeDestroy() {
    this.cancelSearchRequests();
  },
  methods: {
    t: n,
    resetResults() {
      const t = {};
      this.searchProviderIds.forEach((e) => {
        t[e] = {
          entries: []
        };
      }), this.resultsBySearchProvider = t;
    },
    focus() {
      setTimeout(() => {
        this.$refs["search-select"]?.$el?.querySelector("#search-select-input")?.focus();
      }, 300);
    },
    cancelSearchRequests() {
      this.abortController && this.abortController.abort();
    },
    onSearchInput(t, e) {
      this.searchQuery = t, L(() => {
        this.updateSearch();
      }, 500)();
    },
    onSelectResultSelected(t) {
      t !== null && (t.resourceUrl ? (this.cancelSearchRequests(), this.$emit("submit", t.resourceUrl)) : t.isMore && this.searchMoreOf(t.providerId).then(() => {
        this.selectedResult = null;
      }));
    },
    searchMoreOf(t) {
      return this.searchingMoreOf = t, this.cancelSearchRequests(), this.searchProviders(t);
    },
    updateSearch() {
      if (this.cancelSearchRequests(), this.resetResults(), this.searchQuery === "") {
        this.searching = !1;
        return;
      }
      return this.searchProviders();
    },
    searchProviders(t = null) {
      this.abortController = new AbortController(), this.searching = !0;
      const e = t === null ? [...this.searchProviderIds].map((r) => this.searchOneProvider(r)) : [this.searchOneProvider(t, this.resultsBySearchProvider[t]?.cursor ?? null)];
      return Promise.allSettled(e).then((r) => {
        !!r.find((i) => i.status === "rejected" && (i.reason.name === "CanceledError" || i.reason.code === "ERR_CANCELED")) || (this.searching = !1, this.searchingMoreOf = null);
      });
    },
    searchOneProvider(t, e = null) {
      const r = e === null ? p("search/providers/{providerId}/search?term={term}&limit={limit}", { providerId: t, term: this.searchQuery, limit: y }) : p("search/providers/{providerId}/search?term={term}&limit={limit}&cursor={cursor}", { providerId: t, term: this.searchQuery, limit: y, cursor: e });
      return f.get(r, {
        signal: this.abortController.signal
      }).then((s) => {
        const i = s.data.ocs.data;
        this.resultsBySearchProvider[t].name = i.name, this.resultsBySearchProvider[t].cursor = i.cursor, this.resultsBySearchProvider[t].isPaginated = i.isPaginated, this.resultsBySearchProvider[t].entries.push(...i.entries);
      });
    }
  }
};
var Me = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "smart-picker-search", class: { "with-empty-content": e.showEmptyContent } }, [r("NcSelect", { ref: "search-select", staticClass: "smart-picker-search--select", attrs: { "input-id": "search-select-input", label: "name", placeholder: e.mySearchPlaceholder, options: e.options, "append-to-body": !1, "close-on-select": !1, "clear-search-on-select": !1, "clear-search-on-blur": () => !1, "reset-focus-on-options-change": !1, filterable: !1, autoscroll: !0, "reset-on-options-change": !1, loading: e.searching }, on: { search: e.onSearchInput, input: e.onSelectResultSelected }, scopedSlots: e._u([{ key: "option", fn: function(s) {
    return [s.isRawLink ? r("div", { staticClass: "custom-option" }, [r("LinkVariantIcon", { staticClass: "option-simple-icon", attrs: { size: 20 } }), r("span", { staticClass: "option-text" }, [e._v(" " + e._s(e.t("Raw link {options}", { options: s.resourceUrl })) + " ")])], 1) : s.resourceUrl ? r("NcSearchResult", { staticClass: "search-result", attrs: { entry: s, query: e.searchQuery } }) : s.isCustomGroupTitle ? r("span", { staticClass: "custom-option group-name" }, [e.provider.icon_url ? r("img", { staticClass: "provider-icon group-name-icon", attrs: { src: e.provider.icon_url } }) : e._e(), r("span", { staticClass: "option-text" }, [r("strong", [e._v(e._s(s.name))])])]) : s.isMore ? r("span", { class: { "custom-option": !0 } }, [s.isLoading ? r("span", { staticClass: "option-simple-icon icon-loading-small" }) : r("DotsHorizontalIcon", { staticClass: "option-simple-icon", attrs: { size: 20 } }), r("span", { staticClass: "option-text" }, [e._v(" " + e._s(e.t('Load more "{options}"', { options: s.name })) + " ")])], 1) : e._e()];
  } }, { key: "no-options", fn: function() {
    return [e._v(" " + e._s(e.noOptionsText) + " ")];
  }, proxy: !0 }]), model: { value: e.selectedResult, callback: function(s) {
    e.selectedResult = s;
  }, expression: "selectedResult" } }), e.showEmptyContent ? r("NcEmptyContent", { staticClass: "smart-picker-search--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e.provider.icon_url ? r("img", { staticClass: "provider-icon", attrs: { alt: e.providerIconAlt, src: e.provider.icon_url } }) : r("LinkVariantIcon")];
  }, proxy: !0 }], null, !1, 2922132592) }) : e._e()], 1);
}, Ve = [], We = /* @__PURE__ */ o(
  Be,
  Me,
  Ve,
  !1,
  null,
  "97d196f0",
  null,
  null
);
const qe = We.exports, u = {
  providerList: 1,
  standardLinkInput: 2,
  searchInput: 3,
  customElement: 4
}, Te = {
  name: "NcReferencePicker",
  components: {
    NcCustomPickerElement: ue,
    NcProviderList: we,
    NcRawLinkInput: Le,
    NcSearch: qe
  },
  props: {
    /**
     * Provider to select on creation
     * Default: null. Show the provider list
     */
    initialProvider: {
      type: Object,
      default: () => null
    },
    /**
     * Optional width in pixels
     * Default: 100%
     */
    width: {
      type: Number,
      default: null
    },
    /**
     * Focus on the provider list select input on creation
     * Default: true
     */
    focusOnCreate: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "cancel",
    "cancel-raw-link",
    "cancel-search",
    "provider-selected",
    "submit"
  ],
  data() {
    return {
      MODES: u,
      selectedProvider: this.initialProvider
    };
  },
  computed: {
    mode() {
      return this.selectedProvider === null ? u.providerList : d(this.selectedProvider.id) ? u.customElement : this.selectedProvider.search_providers_ids ? u.searchInput : u.standardLinkInput;
    },
    pickerWrapperStyle() {
      return {
        width: this.width ? this.width + "px" : void 0
      };
    }
  },
  mounted() {
    this.focusOnCreate && (this.initialProvider ? setTimeout(() => {
      this.$refs["url-input"]?.focus();
    }, 300) : this.$nextTick(() => {
      this.$refs["provider-list"]?.focus();
    }));
  },
  methods: {
    onEscapePressed() {
      this.selectedProvider !== null ? this.deselectProvider() : this.cancelProviderSelection();
    },
    onProviderSelected(t) {
      this.selectedProvider = t, this.$emit("provider-selected", t), this.$nextTick(() => {
        this.$refs["url-input"]?.focus();
      });
    },
    cancelCustomElement() {
      this.deselectProvider();
    },
    cancelSearch() {
      this.$emit("cancel-search", this.selectedProvider?.title), this.deselectProvider();
    },
    cancelRawLinkInput() {
      this.$emit("cancel-raw-link", this.selectedProvider?.title), this.deselectProvider();
    },
    cancelProviderSelection() {
      this.$emit("cancel");
    },
    submitLink(t) {
      this.selectedProvider !== null && pe(this.selectedProvider.id), this.$emit("submit", t), this.deselectProvider();
    },
    deselectProvider() {
      this.selectedProvider = null, this.$emit("provider-selected", null), setTimeout(() => {
        this.$refs["provider-list"]?.focus();
      }, 300);
    }
  }
};
var je = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "reference-picker", style: e.pickerWrapperStyle, attrs: { tabindex: "-1" }, on: { keydown: function(s) {
    return !s.type.indexOf("key") && e._k(s.keyCode, "esc", 27, s.key, ["Esc", "Escape"]) ? null : (s.stopPropagation(), s.preventDefault(), e.onEscapePressed.apply(null, arguments));
  } } }, [e.mode === e.MODES.providerList ? r("NcProviderList", { ref: "provider-list", on: { "select-provider": e.onProviderSelected, submit: e.submitLink, cancel: e.cancelProviderSelection } }) : e.mode === e.MODES.standardLinkInput ? r("NcRawLinkInput", { ref: "url-input", attrs: { provider: e.selectedProvider }, on: { submit: e.submitLink, cancel: e.cancelRawLinkInput } }) : e.mode === e.MODES.searchInput ? r("NcSearch", { ref: "url-input", attrs: { provider: e.selectedProvider }, on: { cancel: e.cancelSearch, submit: e.submitLink } }) : e.mode === e.MODES.customElement ? r("div", { staticClass: "custom-element-wrapper" }, [r("NcCustomPickerElement", { attrs: { provider: e.selectedProvider }, on: { submit: e.submitLink, cancel: e.cancelCustomElement } })], 1) : e._e()], 1);
}, ze = [], De = /* @__PURE__ */ o(
  Te,
  je,
  ze,
  !1,
  null,
  "aa77d0d3",
  null,
  null
);
const Ae = De.exports;
h(V, M);
const Fe = {
  name: "NcReferencePickerModal",
  components: {
    NcReferencePicker: Ae,
    NcModal: D,
    NcButton: z,
    ArrowLeftIcon: F,
    CloseIcon: Q
  },
  props: {
    /**
     * Provider to select on creation
     * Show the provider list if no initial one is provided
     */
    initialProvider: {
      type: Object,
      default: () => null
    },
    /**
     * Focus on the input item on create
     */
    focusOnCreate: {
      type: Boolean,
      default: !0
    },
    /**
     * If true, add the modal content to the Viewer trap elements via the event-bus
     */
    isInsideViewer: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "cancel",
    "submit"
  ],
  data() {
    return {
      show: !0,
      selectedProvider: this.initialProvider,
      backButtonTitle: n("Back to provider selection"),
      closeButtonTitle: n("Close"),
      closeButtonLabel: n("Close Smart Picker")
    };
  },
  computed: {
    isProviderSelected() {
      return this.selectedProvider !== null;
    },
    showBackButton() {
      return this.initialProvider === null && this.isProviderSelected;
    },
    modalSize() {
      return this.isProviderSelected && d(this.selectedProvider.id) ? re(this.selectedProvider.id) ?? "large" : "normal";
    },
    showModalName() {
      return !this.isProviderSelected || !d(this.selectedProvider.id);
    },
    modalName() {
      return this.isProviderSelected ? this.selectedProvider.title : n("Smart Picker");
    }
  },
  mounted() {
    if (this.isInsideViewer) {
      const t = this.$refs.modal_content;
      A("viewer:trapElements:changed", t);
    }
  },
  methods: {
    onCancel() {
      this.show = !1, this.$emit("cancel");
    },
    onSubmit(t) {
      this.show = !1, this.$emit("submit", t);
    },
    onProviderSelect(t) {
      this.selectedProvider = t, t === null && this.initialProvider !== null && this.onCancel();
    },
    onBackClicked() {
      this.$refs.referencePicker.deselectProvider();
    }
  }
};
var Qe = function() {
  var e = this, r = e._self._c;
  return e.show ? r("NcModal", { staticClass: "reference-picker-modal", attrs: { size: e.modalSize, "can-close": !1 }, on: { close: e.onCancel } }, [r("div", { ref: "modal_content", staticClass: "reference-picker-modal--content" }, [e.showBackButton ? r("NcButton", { staticClass: "back-button", attrs: { "aria-label": e.backButtonTitle, title: e.backButtonTitle }, on: { click: e.onBackClicked }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("ArrowLeftIcon")];
  }, proxy: !0 }], null, !1, 3001860362) }) : e._e(), r("NcButton", { staticClass: "close-button", attrs: { "aria-label": e.closeButtonLabel, title: e.closeButtonTitle, type: "tertiary" }, on: { click: e.onCancel }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("CloseIcon")];
  }, proxy: !0 }], null, !1, 2491825086) }), e.showModalName ? r("h2", [e._v(" " + e._s(e.modalName) + " ")]) : e._e(), r("NcReferencePicker", { ref: "referencePicker", attrs: { "initial-provider": e.initialProvider, "focus-on-create": e.focusOnCreate }, on: { "provider-selected": e.onProviderSelect, submit: e.onSubmit, cancel: e.onCancel } })], 1)]) : e._e();
}, Ue = [], Ge = /* @__PURE__ */ o(
  Fe,
  Qe,
  Ue,
  !1,
  null,
  "3f1a4ac7",
  null,
  null
);
const He = Ge.exports;
async function mt(t = null, e = void 0) {
  return await new Promise((r, s) => {
    const i = "referencePickerModal", c = document.createElement("div");
    c.id = i, document.body.append(c);
    const m = t === null ? null : de(t) ?? null, a = U.extend(He), l = new a({
      propsData: {
        initialProvider: m,
        isInsideViewer: e
      }
    }).$mount(c);
    l.$on("cancel", () => {
      l.$destroy(), s(new Error("User cancellation"));
    }), l.$on("submit", (x) => {
      l.$destroy(), r(x);
    });
  });
}
export {
  te as N,
  Ae as a,
  He as b,
  qe as c,
  Z as d,
  ht as e,
  se as f,
  ie as g,
  d as h,
  G as i,
  mt as j,
  S as k,
  de as l,
  R as m,
  me as n,
  H as r,
  he as s
};
